'use client';

import { RefObject, useEffect } from 'react';

export const useIsVisible = <T extends Element>(
  element: RefObject<T | null>,
  rootMargin: string,
  onVisibilityChange?: (isVisible: boolean) => void,
) => {
  useEffect(() => {
    if (!element.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (onVisibilityChange) {
          onVisibilityChange(entry.isIntersecting);
        }
      },
      { rootMargin },
    );

    observer.observe(element.current);

    return () => {
      if (element.current) {
        observer.unobserve(element.current);
      }
      observer.disconnect();
    };
  }, [element, rootMargin, onVisibilityChange]);
};
